import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

import { makeErrorToast } from '@/vue/composables/toaster';
import type { CustomRoute } from '@/vue/routes';
import ROUTE_NAMES from '@/vue/routes/routeNames';
import { useUserStore } from '@/vue/stores/user';
import type { RouterListener } from './RouterListener';

const EXCLUDED_ROUTES: RouteLocationNormalized['name'][] = [
    ROUTE_NAMES.HOME,
    ROUTE_NAMES.USER_SETTINGS,
];

export default class PermissionRouteListener implements RouterListener {
    public onBeforeEach(to: RouteLocationNormalized): boolean | RouteLocationRaw {
        if (to.meta.anonymous || EXCLUDED_ROUTES.includes(to.name)) {
            return true;
        }

        const { permissions: getPermissions, deniedMessage } = to.meta as CustomRoute['meta'];

        if (!getPermissions) {
            return true;
        }

        const permissions = getPermissions();

        if (permissions.length === 0 || permissions.some(useUserStore().hasPermission)) {
            return true;
        }

        if (deniedMessage) {
            makeErrorToast(deniedMessage);
        }

        return { name: ROUTE_NAMES.HOME };
    }
}
